<div class="text-center sm:px-4 px-0 py-4 w-full">
    <div class="container mx-auto animate-fade-in-up">
        <!-- logo -->
        <h1 class="object-contain mt-3 text-center">
            <img src="assets/images/ui/logo.png" alt=""
                class="cursor-pointer sm:w-[110px] w-[90px] mx-auto">
        </h1>
    
        <div class="lg:mt-14 md:mt-10 sm:mt-8 mt-6">
            <h2 class="text-blue-theme-color sm:text-3xl text-2xl font-bold">Welcome to Phlenu!</h2>
            <p class="sm:text-lg text-base text-[#000000DE] leading-6 max-w-3xl mx-auto sm:mt-4 mt-2 font-medium">You’ve been invited to join Phlenu through an affiliate. Choose your preferred method to get started and enjoy seamless deliveries.</p>
            
            <ng-container *ngIf="isDataLoading;else loadedData">
                <!-- show loading -->
                <div class="flex flex-col items-center justify-center lg:min-h-72 md:min-h-64 sm:min-h-52 min-h-40 pt-10 bg-gray-100 animate-fade-in-up">
                     <!-- Spinner -->
                    <div class="loader-spinner relative sm:w-14 w-10 sm:h-14 h-10 mb-4">
                        <div class="w-full h-full sm:border-4 border-2 border-orange-color border-t-white-color rounded-full animate-spin">
                        </div>
                    </div>
                  
                     <!-- Loading Message -->
                    <p class="sm:text-lg text-base text-gray-700 font-medium">
                        Getting affiliate information, please wait...
                    </p>
                </div>
            </ng-container>

            <ng-template #loadedData>
                <ng-container *ngIf="this.affData;else soError">
                    <div class="md:mt-8 sm:mt-6 mt-4 animate-fade-in-up">
                        <p class="text-base text-[#000000DE] font-medium">Referral Code</p>
                        <div class="bg-titanWhite mt-3 tracking-normal inline-block md:px-9 sm:px-7 px-6 md:py-7 sm:py-5 py-3 sm:text-3xl text-2xl rounded-xl text-blue-theme-color font-medium">{{this.affData?.affiliateCode}}</div>
                    </div> 
        
                    <!-- action options -->
                    <div class="grid sm:mt-14 mt-8 max-w-[950px] mx-auto lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-1 grid-cols-1 sm:gap-4 gap-3 animate-fade-in-up">
                        <!-- webapp -->
                        <div (click)="onWabApp()" class="actionItem actionFlex" matRipple>
                            <img src="assets/images/ui/webapp.png" class="sm:w-auto w-6" alt="">
                            <span class="text-base text-left sm:text-[18px] text-black-color leading-6 font-semibold">Phlenu Delivery Web App</span>
                        </div>
        
                        <!-- whatsapp -->
                        <div (click)="onWhatsapp()" class="actionItem actionFlex" matRipple>
                            <img src="assets/images/ui/whatsapp-icon.png" class="sm:w-auto w-6" alt="">
                            <span class="text-base text-left sm:text-[18px] text-black-color leading-6 font-semibold">Whatsapp Ordering</span>
                        </div>
        
                        <!-- IOS -->
                        <div (click)="onApp(this.affData.deliveryAffiliateLink)" class="actionItem actionFlex" matRipple>
                            <img src="assets/images/ui/ios_icon.png" class="sm:w-36 w-28" alt="">
                        </div>
        
                        <!-- android -->
                        <div (click)="onApp(this.affData.deliveryAffiliateLink)" class="actionItem actionFlex" matRipple>
                            <img src="assets/images/ui/android_icon.png" class="sm:w-36 w-28" alt="">
                        </div>
                    </div>
                </ng-container>
    
                <ng-template #soError>
                    <div class="text-white-color bg-red px-4 py-4 lg:mt-28 md:mt-12 sm:mt-8 mt-8 max-w-3xl text-left mx-auto border border-red rounded-lg animate-fade-in-up">
                        <span class="sm:text-lg text-base font-semibold underline">ERROR:Failed to get infomation.</span>
                        <p class="sm:text-sm text-xs leading-5 mt-2">The affiliate link you are trying to use for registering on Phlenu does not contain a valid affiliate ID. Please contact your affiliate link provider to get the correct link.</p>
                    </div>
                </ng-template>
            </ng-template>
    
        </div>

        <div class="lg:mt-[22vh] md:mt-20 sm:mt-16 mt-12 max-w-xl mx-auto animate-fade-in-up">
            <p class="text-base leading-6 text-[#000000DE] text-center">We’re here to support you every step of the way. If you have any questions, don’t hesitate to reach out.</p>
            <a href="mailto:support@phlenu.com" class="text-blue-dark underline mt-3">{{'support@phlenu.com'}}</a>
        </div>
    </div>
</div>
